import { Auth } from '@angular/fire/auth';
import { Injectable } from '@angular/core';
import {
  Analytics,
  logEvent,
  setUserProperties,
} from '@angular/fire/analytics';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    private fireAnalytics: Analytics,
    private auth: Auth,
  ) {}

  // newAnonymousUser(uid: string) {
  //   logEvent(this.fireAnalytics, 'New_Anonymous_User', {'uid': uid});
  // }

  // setUserTheme(theme: any){
  //   setUserProperties(this.fireAnalytics, {'app_theme': theme})
  // }

  swVersionUpdateFailed(hash: any, error: any) {
    logEvent(this.fireAnalytics, 'SW_VERSION_UPDATE_FAILED', {
      uid: this.auth.currentUser?.uid,
      version_hash: hash,
      error: error,
    });
  }
}
